import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="b2b-users"
export default class extends Controller {
    static targets = ["customersDiv", "radioButtons", 'input', 'scopingView', 'scopingRadio']

    connect() {
        document.addEventListener('turbo:load', this.toggleCustomerDropdowns.bind(this));
        this.inputTargets.forEach((input) => {
            input.addEventListener("keyup", this.validate.bind(this));
        });
        this.radioButtonsTargets.forEach(radio => {
            radio.addEventListener('change', this.toggleCustomerDropdowns.bind(this));
        });

        this.scopingViewTargets.forEach(view => {
            $('select', view).on('change', this.trackScopingEntities.bind(this));
        });

        this.trackScopingEntities();
    }

    disconnect() {
        document.removeEventListener('turbo:load', this.toggleCustomerDropdowns.bind(this));

        this.radioButtonsTargets.forEach(radio => {
            radio.removeEventListener('change', this.toggleCustomerDropdowns.bind(this));
        });
    }

    toggleCustomerDropdowns() {
        const checkedRadioButton = this.radioButtonsTargets.find(r => r.checked)
        if (checkedRadioButton) {
            if (checkedRadioButton.value === 'customer' || checkedRadioButton.value === 'both') {
                this.customersDivTarget.classList.remove('d-none')
            } else {
                this.customersDivTarget.classList.add('d-none')
            }
        }
    }

    validate(event) {
        const input = event.target;
        const errorElement = input.closest(".form-group").querySelector(".invalid-feedback");
        // check if input is valid
        if(input.validity.valid)
        {

            input.classList.remove("is-invalid");
            if (errorElement) {
                errorElement.remove();
            }
        } else{
            if (!errorElement) {
                const error = document.createElement("div");
                error.className = "invalid-feedback";
                error.textContent = input.validationMessage;
                input.closest(".form-group").appendChild(error);
            }
            input.classList.add("is-invalid");
        }
    }

    scopingChanged({ target: { value: scoping } }) {
        this.scopingViewTargets.forEach(view => {
            view.style.display = view.dataset.scoping == scoping ? '' : 'none';
        });
    }

    trackScopingEntities() {
        const isOverride = val => val == 'override';
        const hasSelection = select => !!$(select).val().length

        const overrideSelects = $('select', this.scopingViewTargets.filter(view => isOverride(view.dataset.scoping)));
        const inheritSelects = $('select', this.scopingViewTargets.filter(view => !isOverride(view.dataset.scoping)));

        const overrideRadios = this.scopingRadioTargets.filter(r => isOverride(r.value));
        const inheritRadios = this.scopingRadioTargets.filter(r => !isOverride(r.value));

        const hasOverride = overrideSelects.get().some(hasSelection);
        const hasInherit = inheritSelects.get().some(hasSelection);

        overrideRadios.forEach(r => r.disabled = hasInherit);
        inheritRadios.forEach(r => r.disabled = hasOverride);
    }
}
